import api from "services/api";

export interface IHearingCustomField {
  id: number;
  name: string;
  type: "int" | "bool" | "string" | "date" | "datetime";
  active: boolean;
  customerId: number;
  index: number;
  size: number;
  linkedProperty: string | null;
  linkedBehavior: string | null;
  component: "TextInput" | "RadioButton" | "DateInput";
  container: string;
  defaultValue: string | null;
}

export interface IHearingCustomFieldValue {
  hearingCustomFieldId: number;
  value: string | boolean | number;
}

export const HearingCustomFieldService = {
  async getAll(
    customerId: number,
    active?: number | null,
  ): Promise<IHearingCustomField[]> {
    try {
      const params = new URLSearchParams();
      params.append("customerId", String(customerId));
      if (active !== null && active !== undefined) {
        params.append("active", String(active));
      }

      const response = await api.get(
        `/v1/HearingCustomField/GetAllByCustomerId?${params.toString()}`,
      );

      return response.data.data ?? [];
    } catch (error) {
      console.error("Error fetching hearing custom fields:", error);
      return [];
    }
  },
};
